export default {
    "alerts": {
        "alerts": "Alerts",
        "createAlert": "Create Alert",
        "manageAlerts": "Manage Alerts",
        "alertAlreadyExists": "An alert with that name already exists. Would you like to replace it?"
    },

    "editAlert": {
        "title": "Alert",
        "name": "Name",
        "frequency": "Frequency",
        "days": "Days",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "times": "Times",
        "active": "Active",
        "updateQuery": "Update Query",
        "runQuery": "Run Query",
        "lossDataMessage": "Do you want to leave without saving your modifications?"
    },

    "manageAlerts": {
        "title": "Manage Alerts",
        "edit": "Edit",
        "reorder": "Reorder",
        "remove": "Remove",
        "removeAll": "Remove all"
    },

};
